var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"col-md-4"},[_c('v-select',{staticClass:"col-md-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }